var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCredentialsIconSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3097C0 11.3187 0 11.8671 0.164516 12.1852C0.296129 12.4594 0.515484 12.6787 0.800645 12.8213C0.877419 12.8652 0.965161 12.8871 1.07484 12.909C1.7 11.1761 3.47677 9.95871 5.48387 9.95871C7.49097 9.95871 9.31161 11.1981 9.91484 12.9748H14.3239C15.3329 12.9748 15.8813 12.9748 16.1994 12.8103C16.4735 12.6787 16.6929 12.4484 16.8355 12.1742C17 11.8561 17 11.3077 17 10.2987V3.01613H0V10.3097ZM11.5161 5.94452H14.5323C14.8394 5.94452 15.0806 6.18581 15.0806 6.4929C15.0806 6.8 14.8394 7.04129 14.5323 7.04129H11.5161C11.209 7.04129 10.9677 6.8 10.9677 6.4929C10.9677 6.18581 11.209 5.94452 11.5161 5.94452ZM11.5161 9.96968H14.5323C14.8394 9.96968 15.0806 10.211 15.0806 10.5181C15.0806 10.8252 14.8394 11.0665 14.5323 11.0665H11.5161C11.209 11.0665 10.9677 10.8252 10.9677 10.5181C10.9677 10.211 11.209 9.96968 11.5161 9.96968ZM5.49484 4.63936C6.51484 4.63936 7.34839 5.4729 7.34839 6.4929C7.34839 7.5129 6.51484 8.34645 5.49484 8.34645C4.47484 8.34645 3.64129 7.5129 3.64129 6.4929C3.64129 5.4729 4.47484 4.63936 5.49484 4.63936Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1994 0.164516C15.8813 0 15.3329 0 14.3239 0H2.66516C1.65613 0 1.10774 0 0.789677 0.164516C0.526452 0.296129 0.307097 0.515484 0.164516 0.800645C0.043871 1.02 0.0109677 1.37097 0 1.91935H16.989C16.989 1.37097 16.9452 1.02 16.8355 0.800645C16.7039 0.526452 16.4845 0.307097 16.1994 0.164516Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCredentialsIconSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credentialsIconSelected.ad77b80febf545a916c4df11e4592eb9.svg";